export default __webpack_public_path__ + "static/media/cart.0bf2c7a6.png";